import qs from 'qs';

export const searchStateToUrl = ({ searchType, sortBy, pageSize, viewType, searchState, includePastEvents }) => {
    let url = `${window.location.pathname}?type=${searchType}`;

    if (sortBy) {
        url += `&sort=${sortBy}`;
    }

    if (pageSize) {
        url += `&perPage=${pageSize}`;
    }

    if (viewType) {
        url += `&view=${viewType}`;
    }

    if (searchType === 'events' && includePastEvents) {
        url += '&past=1';
    }

    delete searchState.type;
    delete searchState.sort;
    delete searchState.perPage;
    delete searchState.view;

    if (JSON.stringify(searchState) !== JSON.stringify({})) {
        url += `&${qs.stringify(searchState)}`;
    }

    return url;
};

export const urlToSearchState = ({ search }) => {
    const searchState = qs.parse(search.slice(1));
    delete searchState.past;
    return searchState;
};
